import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationOnixManualUploadPage } from "~/pages/settings/organisations/organisation/onix/organisation-onix-manual-upload-page";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/onix-upload/manual",
)({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.onixUploads") }],
  }),
  component: OrganisationOnixManualUploadPage,
});
